import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, NavigationEnd, Router, RouterEvent, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AgilityRiskNavigationService } from './agility-risk-navigation.service';
import { Observable } from 'rxjs';
import { NgxPermissionsService } from 'ngx-permissions';
import { permissions, storageKeys } from '../agility-risk.constants';
import { LocalStorageService } from 'angular-2-local-storage';

@Injectable({
  providedIn: 'root'
})
export class AgilityRiskRouteGuardService implements CanActivate {
  constructor(private router: Router,
              private route: ActivatedRoute,
              private storage: LocalStorageService,
              private navigationService: AgilityRiskNavigationService,
              private ngxPermissionService: NgxPermissionsService) {
    router.events.pipe(filter((event: RouterEvent) => event instanceof NavigationEnd))
      .subscribe((evt: NavigationEnd) => {
        if (evt.url.startsWith(this.navigationService.moduleBaseAddress) && evt.url != '') {
          let routeSnapshot = this.route.snapshot;
          while (routeSnapshot.firstChild) {
            routeSnapshot = routeSnapshot.firstChild;
          }
          this.navigationService.setNavigationHistory(evt, routeSnapshot.data.key);
        } else if (!evt.url.startsWith(this.navigationService.moduleBaseAddress)) {
          this.navigationService.clearNavHistory();
        }
      });
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise((resolve, reject) => {
      if (next.data.anonymous === true) {
        resolve(true);
      } else {
        this.ngxPermissionService.hasPermission(permissions.canAccessRisk).then((canAccessRisk) => {
          if (canAccessRisk) {
            if (next.data.permissions) {
              this.ngxPermissionService.hasPermission(next.data.permissions).then((hasPermission) => {
                if (hasPermission) {
                  resolve(true);
                } else {
                  resolve(false);
                  this.router.navigateByUrl(this.navigationService.appHomeAddress);
                }
              });
            } else {
              resolve(true);
            }
          } else {
            resolve(false);
            this.router.navigateByUrl(this.navigationService.appHomeAddress);
          }
        });
      }
    });
  }

  canDeactivate(component: any, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.storage.remove(storageKeys.navigationHistory);
    this.storage.remove(storageKeys.surveyKey);
    this.storage.remove(storageKeys.surveyUserId);
    return true;
  }
}
